import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import ImageCropper from "../crop_image/ImageCropper";
import Swal from "sweetalert2";

function EntitasAdd() {
    const navigate = useNavigate();

    const [formValue, setFormValue] = useState({
        cover: null,
        penjelasan: "",
        link: "",
        judul: "",
        link_ig: "",
        link_yt: "",
    });

    const [preview, setPreview] = useState({
        cover: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    // ✅ Batasi hanya file gambar
    const openCropper = (file, imageType) => {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif"];

        if (!allowedTypes.includes(file.type)) {
            Swal.fire({
                title: "File tidak valid",
                text: "Hanya file gambar (JPG, JPEG, PNG, WEBP, GIF) yang diperbolehkan!",
                icon: "warning",
            });
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            setFormValue({
                ...formValue,
                [cropData.imageType]: croppedImage,
            });
            setPreview({
                ...preview,
                [cropData.imageType]: blobUrl,
            });
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
        closeCropper();
    };

    const handleChange = (event) => {
        const { name, value, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file, "cover");
        } else {
            setFormValue({
                ...formValue,
                [name]: value,
            });
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const { cover, link, penjelasan, judul, link_ig, link_yt } = formValue;

        if (!cover || !link || !penjelasan || !judul || !link_ig || !link_yt) {
            Swal.fire({
                title: "Error",
                text: "Semua field harus diisi",
                icon: "error",
            });
            return;
        }

        const FormDataInput = new FormData();
        FormDataInput.append("cover", cover);
        FormDataInput.append("link", link);
        FormDataInput.append("penjelasan", penjelasan);
        FormDataInput.append("judul", judul);
        FormDataInput.append("link_ig", link_ig);
        FormDataInput.append("link_yt", link_yt);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => Promise.reject(error)
            );

            await axios.post(
                `${process.env.REACT_APP_API_URL}/entitas/createEntitas`,
                FormDataInput,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            Swal.fire({
                title: "Sukses",
                text: "Data berhasil ditambah",
                icon: "success",
            });
            navigate("/entitas");
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Data gagal ditambah",
                icon: "error",
            });
            console.error("Gagal menambahkan data:", error.response?.data || error.message);
        }
    };

    return (
        <div className="wrapper recruitment-main">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Entitas</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Tambah Entitas</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Foto</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="cover"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto"
                                                        onChange={handleChange}
                                                    />
                                                    {preview.cover && (
                                                        <div className="preview-container-gallery">
                                                            <img
                                                                src={preview.cover}
                                                                alt="Preview"
                                                                className="preview-image-gallery"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <label>Judul</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="judul"
                                                        placeholder="Masukkan judul"
                                                        value={formValue.judul}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Link</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="link"
                                                        placeholder="Masukkan link"
                                                        value={formValue.link}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Link Instagram</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="link_ig"
                                                        placeholder="Masukkan link Instagram"
                                                        value={formValue.link_ig}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Link YouTube</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="link_yt"
                                                        placeholder="Masukkan link YouTube"
                                                        value={formValue.link_yt}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Penjelasan</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="penjelasan"
                                                        placeholder="Masukkan penjelasan"
                                                        value={formValue.penjelasan}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div>
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/entitas">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>

                                        {cropData.isOpen && (
                                            <ImageCropper
                                                imageSrc={cropData.imageSrc}
                                                setCroppedImage={setCroppedImage}
                                                onCropComplete={applyCrop}
                                                onClose={closeCropper}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default EntitasAdd;
